export const wrapHtmlMail = html => {
    return `
        <!DOCTYPE html>
            <html>
                <head>
                    <meta charset="UTF-8">
                    <style>
                        .text-tiny {
                            font-size: .7em;
                        }
                        .text-small {
                            font-size: .85em;
                        }
                        .text-big {
                            font-size: 1.4em;
                        }
                        .text-huge {
                            font-size: 1.8em;
                        }
                    </style>
                </head>
                <body>${html}</body>
            </html>
    `
}
